export class EndPoints {
    public static auth = {
        login: "auth/login",
        session: "auth/session",
        reset: "auth/resetPassword",
        verify: "auth/verify",
        otp: "auth/otp",
    };

    // Employee
    public static user = {
        crud: "user",
        referTo: "user/ReferTo",
        referToManger: "user/ReferTo/Manager",
        referToAssistant: "user/ReferTo/Assistant",
        assignRole: "user/assignRole",
        changePassword: "user/changePassword",
        resetPassword: "user/resetPassword",
        status: "user/status",
        setManager: "user/setManager",
        setAssistant: "user/setAssistant",
    };

    public static country = {
        /**
         * @method Post @method Get @param {string} id  @method Put @param {string} id @method Delete @param {string} id
         */
        crud: "country",
        /**
         * @method Get
         *  get the refer list
         */
        referTo: "country/ReferTo",
        trashFetchCountry: "country/trash",
        ForceDeleteCountry: "country/forceDelete",
        restoreCountry: "country/restoreCountry",
    };

    public static venues = {
        referTo: "venues/ReferTo",
        crud: "venues",
        details: (id: string) => `venues/${id}`,
        extras: (id: string) => `venues/${id}/extras`,
        events: (id: string) => `venues/${id}/events`,
        payments: (id: string) => `venues/${id}/payments`,
        schedule: "venues/schedule",
    };

    public static guestHouse = {
        crud: "guestHouse",
        schedule: "guestHouse/schedule",
    };

    public static events = {
        crud: "events",
        details: (id: string) => `events/${id}`,
        payments: (id: string) => `events/${id}/payments`,
        // schedule: "event/schedule",
    };

    public static entity = {
        referTo: "entity/ReferTo",
        crud: "entity",
    };

    public static extras = {
        crud: "extras",
        details: (id: string) => `extras/${id}`,
    };

    public static hotels = {
        referTo: "hotels/referTo",
        crud: "hotels",
        // schedule: "hotel/schedule",
    };

    public static payments = {
        crud: "payments",
        details: (id: string) => `payments/${id}`,
    };

    // Region
    public static city = {
        crud: "city",
        referTo: "city/ReferTo",
    }; // GetMethod

    // Roles
    public static role = {
        referTo: "role/ReferTo",
        crud: "role", // GetMethod
        assignPermission: "role/AssignPermission", // Post Method
        revoke: "role/revokePermission", // Put Method
    };

    //  End Management

    public static category = {
        /**
         * @method Post @method Get @param {string} id  @method Put @param {string} id @method Delete @param {string} id
         */
        crud: "categories",
        referTo: "categories/ReferTo",
    };

    public static department = {
        /**
         * @method Post @method Get @param {string} id  @method Put @param {string} id @method Delete @param {string} id
         */
        crud: "Department",
        referTo: "Department/ReferTo",
        setManager: "Department/setManager",
    };

    public static position = {
        crud: "Position",
        referTo: "Position/ReferTo",
        // setManager: "Title/setManager",
    };

    public static title = {
        crud: "Title",
        referTo: "Title/ReferTo",
        // setManager: "Title/setManager",
    };
    public static leaveType = {
        crud: "LeaveType",
        referTo: "LeaveType/ReferTo",
    };

    public static documentType = {
        crud: "DocumentType",
        referTo: "DocumentType/ReferTo",
    };

    public static document = {
        crud: "Document",
        view: "Document/View",
        stats: "Document/stats",
        referTo: "Document/ReferTo",
        employee: "Document/employee",
    };

    public static calendar = {
        crud: "Calendar",
        referTo: "Calendar/ReferTo",
    };

    public static policies = {
        crud: "Policies",
        // referTo: "Policies/ReferTo",
    };

    public static leave = {
        crud: "Leave",
        referTo: "Leave/ReferTo",
        approve: "Leave/approve",
        employee: "Leave/employee",
        request: "Leave/direct-request",
    };
}

export default EndPoints;